
import Vue from "vue";
import { IYearObject } from "../store/state";
import { showMore } from "../store/actions";

// Interfaces for component typechecking!
interface ShowMoreData {}

interface ShowMoreMethods {}

interface ShowMoreComputed {
  items: IYearObject[];
}

interface ShowMoreProps {}

export default Vue.extend<
  ShowMoreData,
  ShowMoreMethods,
  ShowMoreComputed,
  ShowMoreProps
>({
  name: "ShowMore",
  computed: {
    items() {
      return this.$store.getters.items;
    },
  },
  methods: {
    showMore() {
      this.$store.dispatch(showMore(undefined));
    },
  },
  components: {},
});
